import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { BaseEntityService } from "./rest-common.service";
import { Router, ActivatedRoute } from "@angular/router";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class InsertionOrderService extends BaseEntityService {
  // /insertion-order/io_dashboard/
  public resource_url = `${this.BASE_API_URL}/insertion-order/`;
  constructor(public http: HttpClient, public toastr: NotificationService, private router: Router,
    private route: ActivatedRoute,) {
    super();
  }

  // have to fix url for this
  getpoliticalDetails(id): Observable<any> {
    let url = `${this.BASE_API_URL}/advertiser/${id}`;
    return this.get(url);
  }

  getInsertionOrderDashboard() {
    let url = `${this.BASE_API_URL}/insertion-order/`;
    return this.get(url);
  }

  getAllInsertionOrder(params = {}): Observable<any> {
    let params_url = this.convertToString(params)
    let url = `${this.BASE_API_URL}/insertion-order/`;
    if (params_url.length > 0) {
      url = `${this.BASE_API_URL}/insertion-order/?${params_url}`
    }
    return this.get(url);
  }

  getDateStringFromObject(dateObject, time) {
    var dateTimeStr = new Date(dateObject.getTime() - dateObject.getTimezoneOffset() * 60000).toISOString();
    // var dateTimeStr = dateObject.toISOString()
    var dateStr = dateTimeStr.split('T')[0]
    return `${dateStr} ${time}`;
  }

  getDateObjectfromString(dateString) {
    dateString = dateString.replace(' ', 'T');
    var dateObj = new Date(dateString);
    return dateObj;
  }

  mapStartAndEndDate(insertionOrder) {
    insertionOrder.budget_intervals.forEach(flight => {
      flight.start_date = this.getDateStringFromObject(this.getDateObjectfromString(flight.start_date), '00:00:00');
      flight.end_date = this.getDateStringFromObject(this.getDateObjectfromString(flight.end_date), '23:59:59');
    });
  }

  ioStatusUpdate(action: 'activate' | 'deactivate', id, params = {}) {
    let url = this.buildUrl(`${this.BASE_API_URL}/insertion-order/${id}/${action}/`, '', params);
    return this.put(url, {});
  }

  deleteInsertionOrder(params = {}, data): Observable<any> {
    let params_url = this.convertToString(params)
    let url = `${this.BASE_API_URL}/insertion-order/dashboard/delete/`;
    if (params_url.length > 0) {
      url = `${this.BASE_API_URL}/insertion-order/dashboard/delete/?${params_url}`
    }
    return this.put(url, data);
  }

  getIOChangeLogs(id, params ={}) {
    let url = this.buildUrl(`${this.resource_url}${id}/change-log`, '', params);
    return this.get(url);
  }

  getFlightUploadTemplate(params = {}) {
    let url = this.buildUrl(
      `${this.resource_url}download-bulk-upload-template`,
      "",
      params
    );
    return this.get(url);
  }

  uploadFlightsTemplate(params = {}, data) {
    let url = this.buildUrl(
      `${this.resource_url}bulk-upload-flights/`,
      "",
      params
    );
    return this.post(url, data);
  }

  downloadBulkUploadTemplate(params = {}) {
    let url = this.buildUrl(
      `${this.resource_url}download-io-bulk-upload-template`,
      "",
      params
    );
    return this.get(url);
  }

  entityBulkUpload(params = {}, data) {
    let url = this.buildUrl(
      `${this.resource_url}bulk-upload/`,
      "",
      params
    );
    return this.post(url, data);
  }

}
